import { render, staticRenderFns } from "./ImportChangeProduct.vue?vue&type=template&id=316fc021&scoped=true"
import script from "./ImportChangeProduct.vue?vue&type=script&lang=js"
export * from "./ImportChangeProduct.vue?vue&type=script&lang=js"
import style0 from "./ImportChangeProduct.vue?vue&type=style&index=0&id=316fc021&prod&scoped=true&lang=css"
import style1 from "./ImportChangeProduct.vue?vue&type=style&index=1&id=316fc021&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316fc021",
  null
  
)

export default component.exports